import React, { useEffect, useState } from 'react';
import classes from "./styles/jobListing.module.css";
import JobCard from './JobCard';
import { Helmet } from 'react-helmet-async';
import PlaceHolder from './PlaceHolder';
import DetailsSection from './DetailsSection';
import DetailsPlaceHolder from './DetailsPlaceholder';

const JobsListing = ({
  title, subTitle, type, list, loading,
  searchKeyword, metaTitle, metaDescription,
  suggestion, canonicalUrl, countryCode
}) => {
  const [apiLoading, setApiLoading]         = useState(loading);
  const [showNoJobs, setShowNoJobs]         = useState(false);
  const [JobId, setJobId]                   = useState("");
  const [selectJobApiType, setSelectJobApiType] = useState("");

  useEffect(() => { setApiLoading(loading); }, [loading]);

  useEffect(() => {
    if (list?.length > 0) {
      setJobId(list[0].JobId);
      setSelectJobApiType(list[0].apiType);
    }
  }, [list]);

  useEffect(() => {
    if (!loading && list?.length === 0) {
      const timer = setTimeout(() => setShowNoJobs(true), 500);
      return () => clearTimeout(timer);
    } else {
      setShowNoJobs(false);
    }
  }, [loading, list]);

  const buildWebPageSchema = () => ({
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": metaTitle,
    "description": metaDescription,
    "url": canonicalUrl,
    "isPartOf": { "@type": "WebSite", "url": "https://www.fetchjobs.co" },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.fetchjobs.co" },
        { "@type": "ListItem", "position": 2, "name": title,  "item": canonicalUrl }
      ]
    }
  });

  return (
    <div className={classes.container}>
      <Helmet>
        {/* Core */}
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />

        {/* Canonical */}
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

        {/* Open Graph */}
        <meta property="og:type"        content="website" />
        <meta property="og:title"       content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
        <meta property="og:site_name"   content="FetchJobs" />
        <meta property="og:image"       content="https://www.fetchjobs.co/logo.png" />

        {/* Twitter Card */}
        <meta name="twitter:card"        content="summary" />
        <meta name="twitter:title"       content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image"       content="https://www.fetchjobs.co/logo.png" />

        {/* Robots */}
        <meta name="robots" content="index, follow" />

        {/* WebPage schema */}
        {canonicalUrl && (
          <script type="application/ld+json">
            {JSON.stringify(buildWebPageSchema())}
          </script>
        )}
      </Helmet>

      {showNoJobs ? (
        <div className={classes.noResult}>
          <img src="https://cdn-icons-png.flaticon.com/128/159/159469.png" alt="" aria-hidden="true" />
          <h3>No jobs found. Try another keyword!</h3>
        </div>
      ) : (
        <div className={classes.ListingCon}>
          {apiLoading ? (
            <div className={classes.Listings}>
              {[...Array(8)].map((_, i) => <PlaceHolder key={i} />)}
            </div>
          ) : (
            <div className={classes.Listings}>
              {list?.map((project, i) => (
                <div key={i}>
                  <JobCard
                    title={project.title}
                    summary={project.summary}
                    company={project.company}
                    id={project.JobId}
                    datePosted={project.datePosted}
                    apiType={project.apiType}
                    location={project.location}
                    onClick={() => {
                      setJobId(project.JobId);
                      setSelectJobApiType(project.apiType);
                    }}
                    selectedJobId={project.JobId === JobId}
                  />
                </div>
              ))}
            </div>
          )}

          <div className={classes.detailCon}>
            {JobId && selectJobApiType
              ? <DetailsSection JobId={JobId} apiType={selectJobApiType} />
              : <DetailsPlaceHolder />
            }
          </div>
        </div>
      )}
    </div>
  );
};

export default JobsListing;